export const ADD_NEW_NOTIFICATION_SUCCESS = 'ADD_NEW_NOTIFICATION_SUCCESS';
export const ADD_NEW_NOTIFICATION_FAIL = 'ADD_NEW_NOTIFICATION_FAIL';
export const CLEAR_NOTIFICATION = 'CLEAR_NOTIFICATION';
export const SET_LOADING = 'SET_LOADING';
export const SET_FOCUS_OUT = 'SET_FOCUS_OUT';

// AUTH ACTIONS
export const CHANGE_LOCALE = 'CHANGE_LOCALE';
export const LOGIN_USER_SUCCESS = 'LOGIN_USER_SUCCESS';
export const AUTH_LOGIN_STATE_CHECKED = 'AUTH_LOGIN_STATE_CHECKED';
export const LOGOUT_USER_SUCCESS = 'LOGOUT_USER_SUCCESS';
export const REGISTER_USER_SUCCESS = 'REGISTER_USER_SUCCESS';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
export const FORGOT_PASSWORD_FAILED = 'FORGOT_PASSWORD_FAILED';
export const CHANGE_PASS_PROFILE = 'CHANGE_PASS_PROFILE';
export const ACCOUNT_NOT_VERIFY_ERROR = "ACCOUNT_NOT_VERIFY_ERROR";
export const GET_USER_PREFRENCES = "GET_USER_PREFRENCES";
export const GET_USER_INFO = "GET_USER_INFO";
export const SCREEN_LOADING = "SCREEN_LOADING";
export const UPDATE_PRIVACY_SIGN = "UPDATE_PRIVACY_SIGN";
export const CHANGE_PASSWORD_PROFILE = 'CHANGE_PASSWORD_PROFILE';
export const GET_GOOGLE_ACCOUNT_PICTURE = 'GET_GOOGLE_ACCOUNT_PICTURE';
export const GET_GAVATAR_IMAGE_SUCCESS = 'GET_GAVATAR_IMAGE_SUCCESS';

export const LOGIN_FAILED = 'LOGIN_FAILED';
export const LOGIN_START = 'LOGIN_START';
export const LOGIN_SUCCEED = 'LOGIN_SUCCEED';
export const PASSWORD_CREATED = 'PASSWORD_CREATED';
export const SET_USER_VERIFICATION = 'SET_USER_VERIFICATION';

// MENU ACTIONS
export const MENU_SET_CLASSNAMES = 'MENU_SET_CLASSNAMES';
export const MENU_CLICK_MOBILE_MENU = 'MENU_CLICK_MOBILE_MENU';
export const MENU_CONTAINER_ADD_CLASSNAME = 'MENU_CONTAINER_ADD_CLASSNAME';
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = 'MENU_CHANGE_HAS_SUB_ITEM_STATUS';
export const MENU_CHANGE_DEFAULT_CLASSES = 'MENU_CHANGE_DEFAULT_CLASSES';

//USER ACTIONS 
export const USER_GET_LIST_SUCCESS = 'USER_GET_LIST_SUCCESS';
export const USER_ADD_SUCCESS = 'USER_ADD_SUCCESS';
export const USER_SINGLE_SUCCESS = 'USER_SINGLE_SUCCESS';
export const USER_ACTIVE_ROLE_SUCCESS = 'USER_ACTIVE_ROLE_SUCCESS';

//ROLE ACTIONS 
export const ROLE_GET_LIST_SUCCESS = 'ROLE_GET_LIST_SUCCESS';
export const ROLE_ADD_SUCCESS = 'ROLE_ADD_SUCCESS';
export const ROLE_SINGLE_SUCCESS = 'ROLE_SINGLE_SUCCESS';
export const GET_USER_PROFILE = 'GET_USER_PROFILE';

// EXPERIENCE ACTIONS
export const SET_EXPERIENCE_LOADING = 'SET_EXPERIENCE_LOADING';
export const SET_EXPERIENCE_SEARCH_LOADING = 'SET_EXPERIENCE_SEARCH_LOADING';
export const SET_PARTICIPENT_EXPERIENCE_LOADING = 'SET_PARTICIPENT_EXPERIENCE_LOADING';
export const SET_BENCHMARK_LOADING = 'SET_BENCHMARK_LOADING';
export const EXPERIENCE_GET_LIST_SUCCESS = 'EXPERIENCE_GET_LIST_SUCCESS';
export const CHECK_STIMULUS_STATUS_SUCCESS = 'CHECK_STIMULUS_STATUS_SUCCESS';
export const EXPERIENCE_ADD_SUCCESS = 'EXPERIENCE_ADD_SUCCESS';
export const EXPERIENCE_EDIT_SUCCESS = 'EXPERIENCE_EDIT_SUCCESS';
export const EXPERIENCE_CANCEL_SUCCESS = 'EXPERIENCE_CANCEL_SUCCESS';
export const EXPERIENCE_COMPLETE_SUCCESS = 'EXPERIENCE_COMPLETE_SUCCESS';
export const EXPERIENCE_SAVE_SINGLE = 'EXPERIENCE_SAVE_SINGLE';
export const EXPERIENCE_EMPTY = 'EXPERIENCE_EMPTY';
export const UPDATE_STIMULUS = 'UPDATE_STIMULUS';
export const UPDATE_SEARCHKEY = 'UPDATE_SEARCHKEY';
export const UPDATE_SEARCHFILTERS = 'UPDATE_SEARCHFILTERS';
export const ADD_REMOVE_BENCHMARK_SUCCESS = 'ADD_REMOVE_BENCHMARK_SUCCESS';
export const SET_SEARCH_TEXT = 'SET_SEARCH_TEXT';
export const SET_CHECKED = 'SET_CHECKED';
export const SET_SELECTED = 'SET_SELECTED';
export const SET_USER_DROPDOWN = 'SET_USER_DROPDOWN';

export const UPDATE_MERGE_BUTTON_STATUS = 'UPDATE_MERGE_BUTTON_STATUS';
export const UPDATE_SEARCHTEXT = 'UPDATE_SEARCHTEXT';
export const UPDATE_SEARCHUSERS = 'UPDATE_SEARCHUSERS';
export const CLEAR_SEARCH = 'CLEAR_SEARCH';

export const GET_CRETOR_LIST = 'GET_CRETOR_LIST';
export const EXPERIENCES_RELOAD = 'EXPERIENCES_RELOAD';
export const UPDATE_IMMERSION_DATA = 'UPDATE_IMMERSION_DATA';
export const UPDATE_SAFETY_DATA = 'UPDATE_SAFETY_DATA';
export const UPDATE_SPECIAL_PROJECT = 'UPDATE_SPECIAL_PROJECT';
export const TAG_APPLIED = 'TAG_APPLIED';
export const UPDATE_AUDIENCE_IMMERSIONS = 'UPDATE_AUDIENCE_IMMERSIONS';
export const UPDATE_AUDIENCE_SAFES = 'UPDATE_AUDIENCE_SAFES';
export const UPDATE_AGENDA_IMMERSIONS = 'UPDATE_AGENDA_IMMERSIONS';
export const UPDATE_AGENDA_SAFES = 'UPDATE_AGENDA_SAFES';
export const UPDATE_HIGHLIGHTS = 'UPDATE_HIGHLIGHTS';
export const UPDATE_HIGHEST_SEGMENTS = 'UPDATE_HIGHEST_SEGMENTS';
export const UPDATE_LOWEST_SEGMENTS = 'UPDATE_LOWEST_SEGMENTS';
export const UPDATE_THUMBNAIL = 'UPDATE_THUMBNAIL';
export const INIT_THUMBNAIL_UPLOADED = 'INIT_THUMBNAIL_UPLOADED';
export const UPDATE_OVERVIEW_AGENDAS = 'UPDATE_OVERVIEW_AGENDAS';
export const UPDATE_IDENTIFIERS = 'UPDATE_IDENTIFIERS';
export const UPDATE_SESSION_DATA = 'UPDATE_SESSION_DATA';
export const UPDATE_IMMERSION_INDEX = 'UPDATE_IMMERSION_INDEX';
export const UPDATE_SAFETY_INDEX = 'UPDATE_SAFETY_INDEX';
export const UPDATE_FETCHING = 'UPDATE_FETCHING';
export const UPDATE_PAGE = 'UPDATE_PAGE';
export const UPDATE_SEARCH_CLIP_PAGE = 'UPDATE_SEARCH_CLIP_PAGE';
export const UPDATE_SEARCH_SESSION_PAGE = 'UPDATE_SEARCH_SESSION_PAGE';

export const UPDATE_FULL_LOADED_OVERVIEW = 'UPDATE_FULL_LOADED_OVERVIEW';
export const BRAINTRUST_LIST = 'BRAINTRUST_LIST';
export const UPDATE_FREE_TEXT = 'UPDATE_FREE_TEXT';

//Creator Onboarding
export const CREATOR_ON_BOARDING_GET_SUCCESS = 'CREATOR_ON_BOARDING_GET_SUCCESS';
export const CREATOR_ON_BOARDING_UPDATE_SUCCESS = 'CREATOR_ON_BOARDING_UPDATE_SUCCESS';
export const CREATOR_ON_BOARDING_NEXT_PAGE = 'CREATOR_ON_BOARDING_NEXT_PAGE';
export const CREATOR_ONBOARDING_GET_BRAINTRUSTLIST_SUCCESS = 'CREATOR_ONBOARDING_GET_BRAINTRUSTLIST_SUCCESS';
export const UPDATE_ONBOARDING_DATA = 'UPDATE_ONBOARDING_DATA';
export const UPDATE_ONBOARDING_SETTINGS = 'UPDATE_ONBOARDING_SETTINGS';

//Creator Experience Builder
export const EXPERIENCE_BUILDER_LOADING = 'EXPERIENCE_BUILDER_LOADING';
export const CREATOR_EXPERIENCE_BUILDER_GET_SUCCESS = 'CREATOR_EXPERIENCE_BUILDER_GET_SUCCESS';
export const UPDATE_USER_METRICS = 'UPDATE_USER_METRICS';
export const CREATOR_EXPERIENCE_BUILDER_NEXT_PAGE = 'CREATOR_EXPERIENCE_BUILDER_NEXT_PAGE';
export const EMPTY_USER_METRICS = 'EMPTY_USER_METRICS';
export const USER_ATTRIBUTE_GET_SUCCESS = 'USER_ATTRIBUTE_GET_SUCCESS';
export const USER_ATTRIBUTE_UPDATE_SUCCESS = 'USER_ATTRIBUTE_UPDATE_SUCCESS';
export const GET_SESSION_PARTICIPANT = 'GET_SESSION_PARTICIPANT';
export const UPDATE_MARKER_TIME = 'UPDATE_MARKER_TIME';
export const UPDATE_TOTAL_EXPERIENCE_COUNT = 'UPDATE_TOTAL_EXPERIENCE_COUNT';
export const GET_USERMETRICVALUE_SUCCESS = 'GET_USERMETRICVALUE_SUCCESS';
export const GET_HUBS_SUCCESS = 'GET_HUBS_SUCCESS';

//reels
export const CREATOR_REELS_BUILDER_NEXT_PAGE = 'CREATOR_REELS_BUILDER_NEXT_PAGE';
export const REELS_ADD_SUCCESS = 'REELS_ADD_SUCCESS';
export const GET_LIST_EXPERIENCE_REELS_SUCCESS = "GET_LIST_EXPERIENCE_REELS_SUCCESS"
export const REELS_SESSIONS_LIST_SUCCESS = 'REELS_SESSIONS_LIST_SUCCESS';
export const GET_ONLY_REELS_SESSIONS_SUCCESS = 'GET_ONLY_REELS_SESSIONS_SUCCESS';

// Creator Dashboard
export const UPDATE_PROJECTS = 'UPDATE_PROJECTS';
export const GET_PROJECTS_SUCCESS = 'GET_PROJECTS_SUCCESS';
export const ADD_PROJECT_SUCCESS = 'ADD_PROJECT_SUCCESS';
export const UPDATE_PROJECT_SUCCESS = 'UPDATE_PROJECT_SUCCESS';
export const DELETE_PROJECT_SUCCESS = 'DELETE_PROJECT_SUCCESS';
export const INIT_ALERT_STATUS = 'INIT_ALERT_STATUS';
export const GET_PROJECT_EXPERIENCE = 'GET_PROJECT_EXPERIENCE';
export const DELETE_EXPERIENCE_FROM_SESSION = 'DELETE_EXPERIENCE_FROM_SESSION';
export const REBNAME_EXPERIENCE_FROM_SESSION = 'REBNAME_EXPERIENCE_FROM_SESSION';

// Admin Role
export const ADD_ROLE_SUCCESS = 'ADD_ROLE_SUCCESS';
export const UPDATE_ROLE_SUCCESS = 'UPDATE_ROLE_SUCCESS';
export const CHANGE_ROLE_STATUS_SUCCESS = 'CHANGE_ROLE_STATUS_SUCCESS';
export const GET_ALL_ROLES = 'GET_ALL_ROLES';
export const GET_ROLE_BY_ID = 'GET_ROLE_BY_ID';
export const ADD_PROJECT_TO_EXPERIENCE_SUCCESS = 'ADD_PROJECT_TO_EXPERIENCE_SUCCESS';

// Admin User
export const ADD_USER_SUCCESS = 'ADD_USER_SUCCESS';
export const GET_ALL_USERS = 'GET_ALL_USERS';
export const GET_ALL_ADMIN_ROLES = 'GET_ALL_ADMIN_ROLES';
export const GET_ADMIN_USER_DETAILS = 'GET_ADMIN_USER_DETAILS';
export const TRIAL_HEADER = 'TRIAL_HEADER';

// admin Billing
export const GET_BILLING_DETAILS = 'GET_BILLING_DETAILS';

//participant
export const PARTICIPANT_EXPERIENCES_GET_SUCCESS = 'PARTICIPANT_EXPERIENCES_GET_SUCCESS';
export const UPDATE_PLANNING_VALUE = 'UPDATE_PLANNING_VALUE';

// Participant List
export const SET_PARTICIPANT_LIST_LOADING = 'SET_PARTICIPANT_LIST_LOADING';
export const INIT_PARTICIPANT_LIST_DATA = 'INIT_PARTICIPANT_LIST_DATA';
export const INIT_LIST_DETAIL_DATA = 'INIT_LIST_DETAIL_DATA';
export const START_PARTICIPANT_LIST_CREATE = 'START_PARTICIPANT_LIST_CREATE';
export const UPDATE_PARTICIPANT_LISTS = 'UPDATE_PARTICIPANT_LISTS';
export const UPDATE_LIST_PARTICIPANTS = 'UPDATE_LIST_PARTICIPANTS';
export const UPDATE_LIST_DETAIL_PAGE = 'UPDATE_LIST_DETAIL_PAGE';
export const START_ADD_PARTICIPANTS = 'START_ADD_PARTICIPANTS';
export const UPDATE_PARTICIPANT_LIST_MSG = 'UPDATE_PARTICIPANT_LIST_MSG';
export const INIT_PARTICIPANT_LIST_MSG = 'INIT_PARTICIPANT_LIST_MSG';
export const INITI_LIVE_PARTICIPANT_DATA = 'INITI_LIVE_PARTICIPANT_DATA';
export const INITI_EXP_PARTICIPANT_DATA = 'INITI_EXP_PARTICIPANT_DATA';

// Creator Manager
export const GET_PARTICIPANTS_CODE_SUCCESS = 'GET_PARTICIPANTS_CODE_SUCCESS';
export const GET_GRAPH_DATA_SUCCESS = 'GET_GRAPH_DATA_SUCCESS';
export const REMOVE_PARTICIPANT_GRAPH_DATA = 'REMOVE_PARTICIPANT_GRAPH_DATA';
export const INIT_LIVE_ANALYSIS_DATA = 'INIT_LIVE_ANALYSIS_DATA';
export const SET_FILTER = 'SET_FILTER';
export const SET_CODE_LOADING = 'SET_CODE_LOADING';
export const CHANGE_GRAPH_TYPE = 'CHANGE_GRAPH_TYPE';
export const GET_STIMULUS_INFO_SUCCESS = 'GET_STIMULUS_INFO_SUCCESS';
export const SET_START = 'SET_START';
export const UPDATE_START_POSITION = 'UPDATE_START_POSITION';
export const UPDATE_TIME = 'UPDATE_TIME';
export const UPDATE_REQUEST_INTERVAL = 'UPDATE_REQUEST_INTERVAL';
export const UPDATE_TIME_INTERVAL = 'UPDATE_TIME_INTERVAL';
export const GET_GRAPH_DATA_START_BTN_SUCCESS = 'GET_GRAPH_DATA_START_BTN_SUCCESS';
export const START_EPOCH = 'START_EPOCH';
export const GET_SAFETY_GRAPH_DATA_SUCCESS = 'GET_SAFETY_GRAPH_DATA_SUCCESS';
export const LOGIN_DETAILS = 'LOGIN_DETAILS';
export const GET_MANAGE_HUBS_SUCCESS = 'GET_MANAGE_HUBS_SUCCESS';
export const UPDATE_SELECTED_HUBS = 'UPDATE_SELECTED_HUBS';
export const SET_MANAGER_LOADING = 'SET_MANAGER_LOADING';
export const SET_PROJECT_ID = 'SET_PROJECT_ID';
export const SET_TEMP_PROJECT = 'SET_TEMP_PROJECT';

//Videos
export const GET_CONFIGATION = 'GET_CONFIGATION'
export const GET_VDOOTP = 'GET_VDOOTP'

//Analysis
export const SET_ANALYSIS_LOADING = 'SET_ANALYSIS_LOADING'
export const SET_FETCHING_SCORES = 'SET_FETCHING_SCORES'
export const GET_IDENTIFIERS = 'GET_IDENTIFIERS'
export const SAVE_CURRENT_SESSION = 'SAVE_CURRENT_SESSION'
export const UPDATED_TO_LIVE = 'UPDATED_TO_LIVE'
export const SESSION_COMPLETED = 'SESSION_COMPLETED'
export const GET_ALL_GRAPHIC_DATA = 'GET_ALL_GRAPHIC_DATA'
export const INIT_ANALYSIS_DATA = 'INIT_ANALYSIS_DATA'
export const REMOVE_GRAPH_DATA = 'REMOVE_GRAPH_DATA'
export const CHANGE_REALTIME_GRAPH_TYPE = 'CHANGE_REALTIME_GRAPH_TYPE'
export const GET_FETCH_SESSION_MARKERS = 'GET_FETCH_SESSION_MARKERS'
export const UPDATE_LOADED_TIME = 'UPDATE_LOADED_TIME'
export const UPDATE_MARKER_DATA = 'UPDATE_MARKER_DATA'
export const REMOVE_MARKER_DATA = 'REMOVE_MARKER_DATA'
export const UPDATE_MARKER = 'UPDATE_MARKER'
export const GET_SESSION_RANGE = 'GET_SESSION_RANGE'
export const PUT_SEGMENT_AS_CLIP = 'PUT_SEGMENT_AS_CLIP'
export const CLIP_SUCCESS = 'CLIP_SUCCESS';
export const CLIP_RENAME_SUCCESS = 'CLIP_RENAME_SUCCESS';
export const CLIP_SEARCH_RENAME_SUCCESS = 'CLIP_SEARCH_RENAME_SUCCESS';
export const DELETE_CLIP_SUCCESS = 'DELETE_CLIP_SUCCESS';
export const DELETE_SEARCH_CLIP_SUCCESS = 'DELETE_SEARCH_CLIP_SUCCESS';
export const GET_SEGMENT_AS_CLIP = 'GET_SEGMENT_AS_CLIP'
export const GET_SAFETY_OVERALL = 'GET_SAFETY_OVERALL'
export const GET_IMMERSION_OVERALL = 'GET_IMMERSION_OVERALL'
export const EXPERIENCE_CATEGORIES_SUCCESS = 'EXPERIENCE_CATEGORIES_SUCCESS'
export const REMOVE_CLIPED_DATA = 'REMOVE_CLIPED_DATA'
export const UPDATE_CLIPED_DATA = 'UPDATE_CLIPED_DATA'
export const UPDATE_ANALYSE_CLIP_DATA = 'UPDATE_ANALYSE_CLIP_DATA'
export const UPDATE_SESSIOIN_RANGE_BYCLIP = 'UPDATE_SESSIOIN_RANGE_BYCLIP'
export const UPDATE_SESSIOIN_RANGE_LIVE = 'UPDATE_SESSIOIN_RANGE_LIVE'
export const GET_EXCLUDED_PARTICIPANTS = 'GET_EXCLUDED_PARTICIPANTS'
export const REMOVE_ALL_PARTICIPANT = 'REMOVE_ALL_PARTICIPANT'
export const REMOVE_PARTICIPANT_FROM_ALL = 'REMOVE_PARTICIPANT_FROM_ALL'
export const UPDATE_OVERAL_IMMMERSION = 'UPDATE_OVERAL_IMMMERSION'
export const GET_XLSX_SUCCESS = 'GET_XLSX_SUCCESS'
export const INIT_LIVE_AND_COMPLETE = 'INIT_LIVE_AND_COMPLETE'
export const GET_STIMULUS_ANALYSIS = 'GET_STIMULUS_ANALYSIS'
export const GET_REALTIME_IMMERSION_SCORES = 'GET_REALTIME_IMMERSION_SCORES'
export const ADD_OVERVIEW_TO_ANALYSIS_KEY_MOMENT = 'ADD_OVERVIEW_TO_ANALYSIS_KEY_MOMENT';
export const ADD_VIDEO_LENGTH = 'ADD_VIDEO_LENGTH';
export const UPDATE_SETTINGS = 'UPDATE_SETTINGS';
export const UPDATE_FULL_LOAD_ANALYSIS = 'UPDATE_FULL_LOAD_ANALYSIS';
export const CHANGE_ASYNC_THUMBNAIL_IMG = 'CHANGE_ASYNC_THUMBNAIL_IMG';
export const OPTIMIZE_LIVE_GRAPH = 'OPTIMIZE_LIVE_GRAPH';
export const UPDATE_ALL_PARTICIPANT_PILLS = 'UPDATE_ALL_PARTICIPANT_PILLS';
export const SET_FINGER_PULSE = 'SET_FINGER_PULSE';
export const REMOVE_ALL_GRAPH = 'REMOVE_ALL_GRAPH';

//overview Tab
export const SESSION_OVERVIEW = 'SESSION_OVERVIEW'
export const CALCULATE_OVERVIEW_TIME = 'CALCULATE_OVERVIEW_TIME'

// Compare
export const UPDATE_COMPARE_DATA = 'UPDATE_COMPARE_DATA';
export const ADD_COMPARE_DATA = 'ADD_COMPARE_DATA';
export const PROJECT_ID_UPDATE = 'PROJECT_ID_UPDATE';
export const GET_STRIPE_PRODUCT_LIST = 'GET_STRIPE_PRODUCT_LIST';
export const GET_STRIPE_CUSTOMER_DETAIL = 'GET_STRIPE_CUSTOMER_DETAIL';
export const ADD_COMPARE_PATH = 'ADD_COMPARE_PATH';
export const REMOVE_COMPARE_PATH = 'REMOVE_COMPARE_PATH';
export const UPDATE_TABLE_SORT_COMPARE = 'UPDATE_TABLE_SORT_COMPARE';
export const INITIALIZE_SORTING_COMPARE = 'INITIALIZE_SORTING_COMPARE';


//merge clips
export const GET_MERGE_CLIPS = 'GET_MERGE_CLIPS';
//set filter and sort column value
export const SORT_COLUMN_FILTER_VALUE = 'SORT_COLUMN_FILTER_VALUE ';
//set filter and sort column value for project
export const SORT_PROJECT_COLUMN_FILTER_VALUE = 'SORT_PROJECT_COLUMN_FILTER_VALUE';
//set filter and sort column value for reels
export const SORT_REELS_COLUMN_FILTER_VALUE = 'SORT_REELS_COLUMN_FILTER_VALUE';

export const UPDATE_REELS_PAGE='UPDATE_REELS_PAGE';

export const GET_LIVE_PARTICIPANTS = 'GET_LIVE_PARTICIPANTS';
